"use client";

import React from "react";
import { usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { Link } from "@/components/common/Link";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
export default function LatestArticles() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) return <div className="grid grid-cols-1 md:grid-cols-2 gap-10 py-10">
      {[1, 2, 4].map(i => <div key={i} className="space-y-4 animate-pulse">
          <div className="aspect-[16/10] bg-[#604f45]/10 rounded-2xl" />
          <div className="h-6 bg-[#604f45]/10 w-3/4 rounded" />
          <div className="h-4 bg-[#604f45]/10 w-1/2 rounded" />
        </div>)}
    </div>;
  if (error) return <div className="py-20 text-center text-red-400 font-serif">讀取文章失敗</div>;
  if (posts.length === 0) return <div className="py-20 text-center text-[#604f45]/60 font-serif italic">找不到相關文章</div>;
  return <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 lg:gap-x-20 gap-y-20 w-full max-w-6xl mx-auto">
  {posts.map(post => {
      const safeLink = post.link || "#";
      return <article key={post.id} className="group flex flex-col gap-5 h-full">
        
    
        <Link to={safeLink} className="relative aspect-[16/9.5] overflow-hidden rounded-2xl border border-[#7a6a59]/20 shadow-sm block bg-[#f0e7e0] shrink-0">
          <img src={post.featuredImage || "https://images.pexels.com/photos/172218/pexels-photo-172218.jpeg"} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" alt={post.title} />
        </Link>

        <div className="flex-1 flex flex-col justify-between px-2">
          
          {/* 上半部：標題與內文 */}
          <div className="space-y-3">
            {/* 小標籤 */}
            <div className="flex items-center gap-2 text-[10px] tracking-widest text-[#604f45] font-bold uppercase font-sans">
              <span>Knowledge</span>
              <span className="h-1 w-1 rounded-full bg-[#7a6a59]/40" />
              <span>{post.date ? new Date(post.date).toLocaleDateString("zh-TW") : "RECENT"}</span>
            </div>

            {/* 2. 標題點擊跳轉 */}
            <Link to={safeLink} className="block">
              {/* 標題字體與行高微調，呈現舒服的人文閱讀感 */}
              <h3 className="font-hk-regular text-base md:text-lg lg:text-xl font-medium text-[#3d3d3d] group-hover:text-[#604f45] transition-colors line-clamp-2 leading-snug" dangerouslySetInnerHTML={{
                __html: post.title
              }} />
            </Link>

            {/* 文章簡介 */}
            <div className="text-[#3d3d3d]/70 line-clamp-2 text-xs md:text-sm leading-relaxed font-hk-light" dangerouslySetInnerHTML={{
              __html: post.excerpt
            }} />
          </div>

          {/* 下半部：按鈕區（依舊保持橫向絕對同高） */}
          <div className="pt-5">
            <Link to={safeLink} className="block w-full md:w-auto">
              <Button variant="outline" className="w-full md:w-auto md:inline-flex md:px-6 h-10 rounded-full text-xs uppercase tracking-widest border-[#7a6a59] text-[#7a6a59] bg-transparent hover:bg-[#7a6a59] hover:text-white transition-all duration-300 flex items-center justify-center gap-2 cursor-pointer font-sans">
                查看詳情 / VIEW DETAIL <ArrowRight className="size-3.5 transition-transform group-hover:translate-x-1" />
              </Button>
            </Link>
          </div>

        </div>
      </article>;
    })}
</div>;
}